<template>
  <div data-test-id="rating-summary">
    <div v-if="reviewsData?.rollup?.reviewCount" class="self-center">
      <base-link class="gap-2 items-center i-flex" @click="openReviews">
        <vf-rating :value="reviewsData.rollup.averageRating" />
        <span aria-hidden="true" class="text-xs lh-4 underlined">
          ({{ reviewsData.rollup.reviewCount }})
        </span>
        <span class="sr-only">
          {{
            replaceAll(
              $pluralize($t.viewNumberOfReviews, reviewsData.rollup.reviewCount),
              { reviewsCount: reviewsData.rollup.reviewCount },
            )
          }}
        </span>
      </base-link>
    </div>
    <panel-reviews size="lg" />
  </div>
</template>

<script lang="ts" setup>
import type { ProductReviewsData } from '#types/components/product/reviews'

defineProps<{
  reviewsData?: ProductReviewsData
}>()

const { $gtm } = useNuxtApp()
const PanelReviews = createPanel('reviews')

const openReviews = () => {
  $gtm.push('pdpPage.onViewReviews')
  PanelReviews.open()
}
</script>
